import {
  AntibodyEnforcedSchemaSpec,
  getAntibodyEnforcedSchemaRoleFromSpec,
} from 'antibodies/schema-configuration/AntibodyEnforcedDataModelConstants';
import {StaticSchemaInterfaceSummary} from 'schemas/schema-interface/SchemaInterfaceConstants';

import {
  AntibodyComponentSchemaInterfaceApiId,
  isAntibodyComponentSchemaInterfaceId,
  ANTIBODY_COMPONENT_INTERFACE_ID_TO_SCHEMA_ROLE,
  getAntibodySchemaInterfaceFromId,
} from './AntibodySchemaInterfaceConstants';

/**
 * If the field identified by fieldSystemName is owned by the antibody data model, returns the relevant antibody schema interface.
 * Otherwise, returns null.
 * @param fieldSystemName - The system name of the field to find the antibody schema interface for.
 * @param appliedInterfaceIds - The IDs of the interfaces that are applied to the schema.
 * @param enforcedSchemaSpecs - The enforced schema specs that determine which fields on a schema are owned.
 * @returns The relevant antibody schema interface or null.
 */
export default function findAntibodyInterfaceForField(
  fieldSystemName: string,
  appliedInterfaceIds: Array<string>,
  enforcedSchemaSpecs: Array<AntibodyEnforcedSchemaSpec>
): StaticSchemaInterfaceSummary | null {
  const antibodyInterfaceId = appliedInterfaceIds.find((interfaceId) =>
    isAntibodyComponentSchemaInterfaceId(interfaceId)
  );
  if (antibodyInterfaceId == null) {
    return null;
  }
  const antibodySchemaRole =
    ANTIBODY_COMPONENT_INTERFACE_ID_TO_SCHEMA_ROLE[
      antibodyInterfaceId as AntibodyComponentSchemaInterfaceApiId
    ];

  const enforcedSchemaSpec = enforcedSchemaSpecs.find(
    (enforcedSchemaSpec) => getAntibodyEnforcedSchemaRoleFromSpec(enforcedSchemaSpec) === antibodySchemaRole
  );
  if (enforcedSchemaSpec == null) {
    return null;
  }
  if (
    enforcedSchemaSpec.enforcedFieldSpecs.some(
      (enforcedFieldSpec) => enforcedFieldSpec.systemName === fieldSystemName
    )
  ) {
    return getAntibodySchemaInterfaceFromId(antibodyInterfaceId);
  }
  return null;
}
